module.exports = __webpack_public_path__ + "static/img/cdms_logo.1bfeb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cdms_logo.png
// module id = aRSA
// module chunks = 196